    <ng-container *ngFor="let game of allGamesArray">
        <div class="slots_card col-md-2">
            <div class="slot_rect_card">
                <app-lobby-game-card [game]="game" [isFavourite]="favItemObj[game.gameCode]" [liveGameDetails]="liveTableData[game.pristineGameId]">
                </app-lobby-game-card>
            </div>
        </div>
    </ng-container>

<!-- Desktop Games preloading Icon -->
<div class="loading_icon clearfix">
    <div class="loading_outer-space" *ngIf="onScrollLoadGames">
        <div class='loader'></div>
    </div>
</div>

<ng-container *ngIf="allGamesArray && allGamesArray.length === 0">
    <div class="slot_games--wrap slotsContentBlock">
        <p class="no-games">{{'gamingComp.gaming24' | translate}}</p>
    </div>
</ng-container>